import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const DEFAULT_SETTINGS = {
  workshop_name: "MotorWerk",
  tagline: "Kfz-Meisterbetrieb",
  address_line1: "Industriestraße 42",
  address_line2: "10115 Berlin",
  phone: "030 / 12 34 567",
  email: "info@motorwerk.de",
  hours_weekdays: "08:00 – 17:00",
  hours_sunday: "Geschlossen",
  footer_note:
    "Ihre vertrauenswürdige Kfz-Werkstatt in Ihrer Nähe. Präzise Diagnose, faire Preise, ehrliche Beratung.",
  notification_email: "",
  logo_url: "",
  hero_car_url: "",
  hero_sound_url: "",
  slogan: "Leidenschaft trifft Qualität",
  tagline_bottom: "Dein Auto. Unsere Passion.",
  hero_description: "Wir bieten professionelle Fahrzeugpflege, Reparaturen und individuelle Lösungen für dein Auto.",
  instagram_handle: "",
  copyright_text: "© 2026 OG's Garage · Alle Rechte vorbehalten",
  imprint_owner: "",
  imprint_ustid: "",
  imprint_register: "",
  imprint_responsible: "",
  imprint_additional: "",
  tagline_en: "",
  slogan_en: "",
  hero_description_en: "",
  tagline_bottom_en: "",
  footer_note_en: "",
  copyright_text_en: "",
  promo_sticker_headline_en: "",
  promo_sticker_subline_en: "",
  imprint_additional_en: "",
  promo_sticker_active: false,
  promo_sticker_headline: "",
  promo_sticker_subline: "",
};

export function useSettings() {
  const q = useQuery({
    queryKey: ["settings"],
    queryFn: () => api.get("/settings").then((r) => r.data),
    staleTime: 60_000,
  });
  return q.data || DEFAULT_SETTINGS;
}
